module.exports = __webpack_public_path__ + "img/17_87.ab13ca93.png";